<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/mixins/api'

export default {
  name: 'app',
  computed: {
    ...mapGetters(['user']),
    nextRoute() {
      return this.$route.query.redirect || '/'
    },
  },
  watch: {
    user(auth, old) {
      if (!auth || !old) {
        this.$router.replace(this.nextRoute)
      }
    },
    '$route'(to, from) {
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
  methods: {
    loadMetadata() {
      const userInfo = this.$auth.user()
      if ( userInfo && userInfo.uid ) {
        this.api('user').then(metadata => {
          this.$store.commit('UPDATE_USER', { metadata })
        })
      }
    }
  },
  mounted() {
    this.loadMetadata()
    window.onAuthStateChanged = () => {
      this.loadMetadata()
    }
  },
  mixins: [api]
}
</script>
